import { useTranslation } from 'react-i18next';

import { Box, Stack } from '@mui/material';

import Typography from '../../../../components/Typography';
import { i18nNS } from '../../../../i18n';

export interface ErrorsListProps {
  errors:
    | {
        [fieldName: string]: string | string[] | Record<string, string> | undefined;
      }
    | undefined;
}

const ErrorsList = ({ errors }: ErrorsListProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  if (!errors) return null;

  return (
    <Stack gap={2}>
      <Typography variant="h6Medium" color="common.black" component="p">
        {t('please_fix_these_errors_before_publishing_poll', { ns: i18nNS.POLL })}
      </Typography>
      <Box m={0} p={0} component="ul">
        {Object.keys(errors).map((fieldName) => {
          const error = errors[fieldName];

          if (typeof error === 'string') {
            return (
              <Stack key={fieldName} direction="row" alignItems="center" gap={2} component="li">
                <Typography variant="paragraphBold">{fieldName}:</Typography>
                <Typography variant="paragraphRegular">{error}</Typography>
              </Stack>
            );
          }

          if (typeof error === 'object' && Array.isArray(error)) {
            if (error.length === 0) return null;
            return (
              <Stack key={fieldName} direction="row" alignItems="center" gap={2} component="li">
                <Typography variant="paragraphBold">{fieldName}:</Typography>
                <Box m={0} px={4} py={0} component="ul">
                  {error.map((errorMessage) => {
                    return (
                      <li key={errorMessage}>
                        <Typography variant="paragraphRegular">{errorMessage}</Typography>
                      </li>
                    );
                  })}
                </Box>
              </Stack>
            );
          }

          if (typeof error === 'object') {
            if (Object.keys(error).length === 0) return null;
            return (
              <Stack key={fieldName} component="li">
                <Typography variant="paragraphBold">{fieldName}:</Typography>
                <Box m={0} px={4} py={0} component="ul">
                  {Object.entries(error).map(([errorKey, errorValue]) => {
                    return (
                      <Stack
                        key={errorKey}
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        gap={2}
                        component="li"
                      >
                        <Typography variant="paragraphBold">{errorKey}:</Typography>
                        <Typography variant="paragraphRegular">{errorValue}</Typography>
                      </Stack>
                    );
                  })}
                </Box>
              </Stack>
            );
          }

          return null;
        })}
      </Box>
    </Stack>
  );
};

export default ErrorsList;
